import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer, lazyProvider } from '@1inch-community/core/lazy';
import { dispatchEvent, observe } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/card';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { defer, map } from 'rxjs';
import '../shared-elements/token-list';
import { selectTokenContext } from './context';
import './elements/select-token-header';
import { SelectTokenContext } from './select-token.context';
import { selectTokenStyle } from './select-token.style';
let SelectTokenElement = class SelectTokenElement extends LitElement {
    constructor() {
        super(...arguments);
        this.mobileView = false;
        this.applicationContext = lazyAppContextConsumer(this);
        this.selectTokenContext = lazyProvider(this, { context: selectTokenContext });
        this.chainListView$ = defer(() => this.selectTokenContext.value.chainFilter$);
        this.tokenListFlatView$ = defer(() => this.selectTokenContext.value.tokenListFlatView$);
        this.activeAddress$ = defer(() => this.applicationContext.value.wallet.data.activeAddress$);
        this.searchToken$ = defer(() => this.selectTokenContext.value.searchToken$);
        this.tokenListType$ = this.tokenListFlatView$.pipe(map((state) => (state ? 'flat' : 'accordion')));
        this.favoriteTokenIds$ = defer(() => this.applicationContext.value.tokenStorage.liveQuery(() => this.applicationContext.value.tokenStorage.getAllFavoriteTokenIds()));
    }
    static { this.tagName = 'inch-select-token'; }
    static { this.styles = selectTokenStyle; }
    render() {
        this.initContext();
        return html `
      <inch-token-list
        showFavoriteTokenToggle
        type="${observe(this.tokenListType$, 'accordion')}"
        .searchFilter="${observe(this.searchToken$)}"
        .chainIds="${observe(this.chainListView$)}"
        .walletAddress="${observe(this.activeAddress$)}"
        .mobileView="${this.mobileView}"
        .favoriteTokenIds="${observe(this.favoriteTokenIds$)}"
        .header="${() => html `<inch-select-token-header></inch-select-token-header>`}"
        @selectToken="${(event) => {
            this.selectTokenContext.value.onSelectToken(event.detail.value);
            dispatchEvent(this, 'backCard', null);
        }}"
        @changeSearchState="${(event) => {
            this.selectTokenContext.value.setSearchState(event.detail.value);
        }}"
        @favoriteToken="${async (event) => {
            const [isFavorite, tokenId] = event.detail.value;
            await this.applicationContext.value.tokenStorage.changeFavoriteToken(tokenId, isFavorite);
        }}"
      ></inch-token-list>
    `;
    }
    initContext() {
        const swapContext = this.applicationContext.value.getActiveSwapContext();
        if (this.selectTokenContext.isInit || !swapContext || !this.tokenType) {
            throw new Error('error of init SelectTokenContext');
        }
        const context = new SelectTokenContext(this.tokenType, this.applicationContext.value, swapContext);
        this.selectTokenContext.set(context);
    }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], SelectTokenElement.prototype, "tokenType", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], SelectTokenElement.prototype, "mobileView", void 0);
SelectTokenElement = __decorate([
    customElement(SelectTokenElement.tagName)
], SelectTokenElement);
export { SelectTokenElement };
//# sourceMappingURL=select-token.element.js.map